import React from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { S3_BUCKET_NAME } from 'config';
import { Nullable } from 'global';

interface Props {
  partnerLogo?: Nullable<string>;
}

export const PartnerLogoCell = ({ partnerLogo }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.partnerLogo}>
      {partnerLogo ? <img src={`https://${S3_BUCKET_NAME}.s3-us-west-2.amazonaws.com/${partnerLogo}`} /> : <></>}
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  partnerLogo: {
    height: 40,
    width: 130,
    '& img': {
      height: 'inherit',
      width: 'inherit',
      objectFit: 'contain',
    },
  },
}));
